export default "__VITE_ASSET__DdljPESU__"